
const initComponent = (componentNode) => {
    let block = componentNode;
    let links = block.querySelectorAll('.jsTabLink');
    let items = block.querySelectorAll('.jsTabItem');

    initTabs()

    for (let index = 0; index < links.length; index++){
        let link = links[index];
        let linkIndex = link.getAttribute('data-tab');

        link.addEventListener('click', function(){
            clear()
            link.classList.add('is-active');

            if(block.querySelector('.jsTabItem[data-tab="'+ linkIndex +'"]')){
                block.querySelector('.jsTabItem[data-tab="'+ linkIndex +'"]').classList.add('is-active');
            }
        })

        if(links.length < 2){
            link[0].classList.add('is-active');

            if(block.querySelector('.jsTabItem[data-tab="'+ link[0].getAttribute('data-tab') +'"]')){
                block.querySelector('.jsTabItem[data-tab="'+ link[0].getAttribute('data-tab') +'"]').classList.add('is-active');
            }
        }
    }

    function checkActveLink(){
        if (!block.querySelector('.jsTabLink.is-active')){
            block.querySelectorAll('.jsTabLink')[0].classList.add('is-active');
        }

        let activeLink = block.querySelector('.jsTabLink.is-active');
        let activeIndex = activeLink.getAttribute('data-tab');
        
        if(block.querySelector('.jsTabItem[data-tab="'+ activeIndex +'"]')){
            block.querySelector('.jsTabItem[data-tab="'+ activeIndex +'"]').classList.add('is-active');
        }
    }

    function initTabs(){
        initGroup(links);
        initGroup(items);
        checkActveLink();
        
        function initGroup(group) {
            for (let index = 0; index < group.length; index++){
                let groupItem = group[index]
                groupItem.setAttribute('data-tab', index);
            }
        }
    }

    function clear() {
        for (let index = 0; index < links.length; index++){
            let link = links[index]
            link.classList.remove('is-active');
        }
        for (let index = 0; index < items.length; index++){
            let item = items[index]
            item.classList.remove('is-active');
        }
    }
}  

document.addEventListener('DOMContentLoaded', () => {
    const componentNodes = Array.from(document.querySelectorAll('.jsTabs'));

    componentNodes.forEach(initComponent);
});

